import moment from "moment-timezone";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

export function CustomCellDate({ date }: { date: string }) {
  const { i18n } = useTranslation();

  if (!date) return "";

  const d = moment(date).locale(i18n.language);
  const day = d.format("DD MMMM YYYY");
  const time = d.format("HH:mm:ss");

  return (
    <div>
      <Typography variant="body2" color="textPrimary">
        {day}
      </Typography>{" "}
      <Typography variant="body2" color="textSecondary">
        {time}
      </Typography>
    </div>
  );
}
